// extracted by mini-css-extract-plugin
export default {"root":"_2axIp","stats":"_17KSg","boosted":"_36hy5","boosted-text":"_3FsAC","boostedText":"_3FsAC"};